<div class="dhl-readonly-field-v2" [formGroup]="frmGroup" [hidden]="this.frmGroup.get(this.configData.name)['hidden']">
    <div class="readonly-field-wrapper">
        <div class="readonly-field-control" #formControl>
            <div>
                <span class="readonly-field-label">
                    <label class="base-label">
                        {{configData?.label}}<span *ngIf="configData?.required"> *</span>
                    </label>
                </span> 
               </div> 
            <input type="text"
               class="base-field" autocomplete="off" 
                [formControlName]="$safeNavigationMigration(configData?.name)"
                [readonly] = "true"> 
        </div>
    </div>
</div>